import { Component, ContentChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigRepository } from '../../../../../shared/repositories/config.repository';
import { LangOption } from '../../../../../shared/tokens/langOptions/lang-option.interface';
import { LANG_OPTIONS } from '../../../../../shared/tokens/langOptions/lang-options';
import { WINDOW } from '../../../../../shared/tokens/window';
import { Observable, tap } from 'rxjs';
import { LangSwitchToggleDirective } from './lang-switch-toggle.directive';
import { LangSwitchTextDirective } from './lang-switch-text.directive';
import { Router } from '@angular/router';

@Component({
  selector: 'app-lang-switch',
  standalone: true,
  templateUrl: './lang-switch.component.html',
  styleUrls: ['./lang-switch.component.scss'],
  imports: [
    CommonModule
  ]
})
export class LangSwitchComponent {
  constructor(
    private configRepository: ConfigRepository,
    private router: Router,
  ) { }

  @ContentChild(LangSwitchToggleDirective) toggle!: LangSwitchToggleDirective;
  @ContentChild(LangSwitchTextDirective) buttonTextDirective!: LangSwitchTextDirective;

  langPlaceholder: string = $localize`:@@Language:Language`;

  private window = inject(WINDOW);
  langOptions: {[key: string]: LangOption} = inject(LANG_OPTIONS);
  langKeys: string[] = Object.keys(this.langOptions);

  isShowModal: boolean = false;

  buttonText: string;
  currentLocale$: Observable<string | null> = this.configRepository.userLocale$.pipe(
    tap((currentLocale) => {
      this.buttonText = this.getLangTitle(currentLocale);
      this.buttonTextDirective?.setText(this.buttonText);
    })
  );

  onOpen(){
    this.isShowModal = true;
  }

  onClose () {
    this.isShowModal = false;
  }

  onSelectLang (langKey: string, currentLocale: string | null) {
    if(langKey === currentLocale){return}

    this.configRepository.setUserLocale(langKey)

    this.window.location.href = `/${langKey}${this.router.url}`
  }

  getLangTitle(currentLocale: string | null): string {
    return currentLocale ? this.langOptions[currentLocale].translateName : this.langPlaceholder;
  }
}
